<!--
* UIID: UI-DLB-FF-140
* UI Name: FlatFile Layout Check In
* Modify Date: 2020/05/12
-->
<template>
  <dialog-drag
    :id="id"
    :ref='"dialog-" + id'
    @close="removeDialog"
    @drag-end="dialogDragEnd"
    @drag-start="selectDialog"
    @move="dialogDragEnd"
    class="dialog-drag-display add-map-layout-dialog custom-add-map-layout-dialog"
  >
    <!-- [S]  Popup title-->
    <template v-slot:title>
      <v-card-title
        class="headline white--text"
        primary-title
      >{{$t('lbl.flatFileLayout.flatFileCheckIn.page_header')}}</v-card-title>
    </template>
    <template v-slot:button-close>
      <v-icon class="ma-2" small @click="removeDialog" color="white">fas fa-times</v-icon>
    </template>
    <!-- [E]  Popup title-->

    <!-- [S]  Popup body-->
    <v-card class="dialog-container">
      <v-form ref="form" class="dialog-content">
        <v-row>
          <v-col lg="3" class="required-col field-col pt-0 pb-0">
            <v-label>
              <v-icon x-small class="mr-1">fa fa-asterisk</v-icon>
              {{$t('lbl.flatFileLayout.addFlatFile.flatFile')}}
            </v-label>
          </v-col>
          <v-col lg="9"
                class="map-text-field inline-block-component pt-0 pb-0 pl-0 pr-3">
            <v-text-field
              v-model="contenInput"
              class="data-table-filter-text-field inline-block-component"
              type="text"
              heigth="30"
              solo
              readonly
              :rules="[validationUtils.required]"
            ></v-text-field>
          
            <input
              id="edifile"
              type="file"
              ref="edifile"
              style="display: none"
              @change="onFileChanged"
            />
            <v-btn
              @click="clickBrowse()"
              class="btn btn-search text-right"
              color="primary"
            >{{$t('btn.common.browse')}}</v-btn>
          </v-col>
        </v-row>
        <v-row class="pt-0">
          <v-col lg="3" class="required-col field-col pt-0 pb-0">
            <v-label>
              <v-icon x-small class="mr-1">fa fa-asterisk</v-icon>
              {{$t('lbl.flatFileLayout.addFlatFile.comment')}}
            </v-label>
          </v-col>
          <v-col lg="9"
                class="map-text-field inline-block-component pl-0 pt-0 pb-0">
            <v-text-field
              v-model="contentComment"
              ref="comRef"
              class="data-table-filter-text-field inline-block-component text-field-flatfile-layout flatfile-textfield"
              type="text"
              solo
              :rules="[validationUtils.required]"
            ></v-text-field>
          </v-col>
        </v-row>
        <!-- [S]  Popup button-->
        <v-row class="pt-0">
          <v-col lg="12">
            <div class="btn-form-control text-right">
              <v-btn class="btn btn-search" color="primary" @click="saveCheckIn()">
                <v-icon x-small class="mr-2">fas fa-save</v-icon>
                {{$t('btn.common.save')}}
              </v-btn>
              <v-btn class="btn btn-delete" @click="removeDialog">
                <v-icon small color="white" class="mr-1">fa fa-times</v-icon>
                {{$t('btn.common.cancel')}}
              </v-btn>
            </div>
          </v-col>
        </v-row>
        <v-spacer></v-spacer>
        <!-- [E]  Popup button-->
        <!-- [E]  Popup body-->
      </v-form>
    </v-card>
    <dialogWindow
      ref="successDialog"
      :detail="$t('msg.common.success.detail',['EDI File','uploaded'])"
      @select-ok="onClickOkay"
      color="success"
      size="max"
      title="Success"
    ></dialogWindow>
    <dialogWindow
      ref="detailDialog"
      :detail="detailDialog"
      @select-ok="onClickOkayAlert"
      color="warning"
      size="max"
    ></dialogWindow>
  </dialog-drag>
</template>

<script>
/* globals Store */

import DialogDrag from '@/vue-dlb/components/vue-dialog-drag.vue';
import { mapState } from "vuex";
import {UploadFile} from '@/vue-dlb/models'
import dialogWindow from '@/vue-dlb/components/NewDialog.vue'

import {
  showProgress,
  hideProgress,
} from "@/vue-dlb/utils/sys-util.js";


export default {
  components: {
    DialogDrag,
    dialogWindow
  },
  name: 'flatfile-checkin-dialog',
  // props: ['id', 'title', 'options', 'eventCb', 'closeDialog', 'dragStart', 'dragEnd', 'queryList','callby','reFreshList','versionList'],
  props:{
    id: String,
    title: String,
    options: Object,
    eventCb: Function,
    closeDialog: Function,
    dragStart: Function,
    dragEnd: Function,
    reFreshList: Function,
    versionList: Object,
  },
  computed: {
    ...mapState("common", {
      uploadedFile: "uploadedFile"
    }),
  },
  data(){
    return{
    successDialog: false,
    contenInput: '',
    contentComment: '',
    isValidU: false,
    isValidC: false,
    detailDialog: '',
    uploadCheckIn: {
      header: ['CUST_ID', 'USER_ID', 'FFL_PRCS_NO', 'FFL_FILE_NAME', 'FILE_ID', 'FILE_SIZE', 'CHKIN_COMT', 'fflfile'],
      data: [{
        CUST_ID:'',
        USER_ID:'',
        FFL_PRCS_NO:'',
        FFL_FILE_NAME:'',
        FILE_ID:'',
        FILE_SIZE:'',
        CHKIN_COMT:'',
        fflfile:null,
      }],
    },
    lockItems:{
      header: ['FFL_PRCS_NO','LOCK_YN'],
      data: [{
        FFL_PRCS_NO:'',
        LOCK_YN:''
      }],
    },
  }},
  
  methods: {
    saveCheckIn () {
      if (this.contenInput.trim() == '' || this.contentComment.trim() == '') {
        if (this.contenInput.trim() == '' && this.contentComment.trim() == '') {
          this.isValidU = true;
          this.isValidC = true;
          this.detailDialog = "Flatfile Layout, Comment are required.";
        } else if (this.contenInput.trim() == '') {
          this.isValidU = true;
          this.isValidC = false;
          this.detailDialog = "Flatfile Layout is required.";
        } else if (this.contentComment.trim() == '') {
          this.isValidC = true;
          this.isValidU = false;
          this.detailDialog = "Comment is required.";
        }
        this.$refs.detailDialog.dialog = true;
        return;
      }
      let validResult = this.$refs.form.validate();
      if (validResult) {
        console.log("--------- savaData ----------");

        if(this.$refs.edifile.files[0]) {
          // let uploadfile = new UploadFile();
          this.uploadCheckIn.data[0].CUST_ID = $cookies.get('comp-id');
          this.uploadCheckIn.data[0].USER_ID = $cookies.get('user-id');
          this.uploadCheckIn.data[0].FFL_PRCS_NO = this.versionList.FFL_PRCS_NO;
          this.uploadCheckIn.data[0].FFL_FILE_NAME = '';
          this.uploadCheckIn.data[0].FILE_ID = '';
          this.uploadCheckIn.data[0].FILE_SIZE = '';
          this.uploadCheckIn.data[0].CHKIN_COMT = this.contentComment;
          this.uploadCheckIn.data[0].fflfile = this.$refs.edifile.files[0];
          // Upload Flat File Data
          showProgress()
          // Upload EDI File Data
          Store.dispatch("fflayout/checkInFFLayout", this.uploadCheckIn).then(() => {
            console.log("--------- Finished to process ----------");
            hideProgress();
            this.$refs.successDialog.dialog = true;
          });
        }
      }
      return validResult;
    },
    onClickOkayAlert(){
      let self = this;
      setTimeout(() => {
        self.$refs.comRef.focus();
      }, 600);
    },
    onClickOkay(){
      this.onClickOkaySave();
      this.removeDialog({})
    },
    onClickOkaySave (){
        this.lockItems.data[0].FFL_PRCS_NO = this.versionList.FFL_PRCS_NO;
        this.lockItems.data[0].LOCK_YN = 'N';

        Store.dispatch("fflayout/updateLock", this.lockItems).then(() => {
          console.log("--------- Finished to process ----------");
          this.reFreshList();
        });
      },
    clickBrowse() {
      this.$refs.edifile.click();
    },
    onFileChanged(e) {
      this.contenInput = e.target.files[0].name;
    },
    removeDialog (dialog) {
      dialog.id = this.id;
      this.closeDialog(dialog);
    },
    selectDialog (obj) {
      this.dragStart(obj);
    },
    dialogDragEnd (obj) {
        this.dragEnd(obj);
    }
  },
  
  mounted() {
    setTimeout(() => {
        this.$refs.comRef.focus();
    }, 300);
  },
}
</script>
